import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Store } from '@ngxs/store';
import { AuthState } from './state/auth/auth.state';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    const isLoggedIn = this.store.selectSnapshot(AuthState.getLoggedIn);
    if (isLoggedIn) {
        return isLoggedIn;
    }

    // isLoggedIn route return a 401 forbidden when not logged in.
    // We'd expect it to a return 200 with a boolean body, but instead we're using the AJAX
    // library error handler to detect when the user isn't logged in.
    return this.authService.isLoggedIn().toPromise()
        .then((value: { signed_in: boolean }) => {
            if (value.signed_in) {
              return true;
            } else {
              this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
              return false;
            }
        });
  }
}
